export default __webpack_public_path__ + "static/background-a9c2c111b14da8258f45ee2b6936e03a.png";